import { DatePicker as AntdDatePicker } from "antd";
import momentGenerateConfig from "rc-picker/lib/generate/moment";
const DatePicker = AntdDatePicker.generatePicker(momentGenerateConfig);
export { DatePicker };
